import { useLDFlagValue } from 'common/useLDFlagValue';
import { RELEASE_DSI_DASHBOARD } from 'common/constants';
import { hasUserRoles, UserRole } from 'user';
import { DECISION_INTERVENTION_PATH } from './constants';

export const ENTRY_PERMISSION = 'clinical-admin';

const displayLink = (user) => {
  const isReleaseEnabled = useLDFlagValue(RELEASE_DSI_DASHBOARD);
  return (
    Boolean(isReleaseEnabled) && hasUserRoles(user, [UserRole.clinicalAdmin])
  );
};

export const ENTRY_LINK = {
  path: DECISION_INTERVENTION_PATH,
  text: 'Decision Support Intervention',
  icon: 'warning',
  permission: ENTRY_PERMISSION,
  ldFlag: RELEASE_DSI_DASHBOARD,
  module: 'decision-intervention',
  component: 'Dashboard',
  displayLink: displayLink,
};
